import React from 'react';
import { NavLink } from 'react-router-dom';
import avatar from '../../assets/img/avatars/avatar.png';
import { useSidebar } from '../../contexts/SidebarContext';

const Header = () => {
  const { toggleSidebar } = useSidebar();
  const logOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login'; // to check
  }
  // Get role from localStorage
  const role = localStorage.getItem('role');

  // Map roles to dashboard titles
   const roleTitleMap = {
    admin: 'Admin',
    event: 'Event',
    finance: 'Finance',
    management: 'Management'
  };

  // Get title based on role, fallback to "Dashboard"
  const dashboardTitle = `${roleTitleMap[role] || ''} Dashboard`;
  return (
    <nav className="navbar navbar-expand navbar-light navbar-bg">
     <NavLink className="sidebar-toggle js-sidebar-toggle" onClick={toggleSidebar}>
        <i className="hamburger align-self-center"></i>
      </NavLink>
      <h3>{dashboardTitle}</h3>
      <div className="navbar-collapse collapse">
        <ul className="navbar-nav navbar-align">
          <li className="nav-item dropdown">
            <NavLink
              className="nav-icon pe-md-0 dropdown-toggle show"
              to="#"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <img src={avatar} className="avatar img-fluid rounded" alt="John Doe" />
            </NavLink>
            <div className="dropdown-menu dropdown-menu-end" data-bs-popper="static">
              <NavLink to="/" className="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user align-middle me-1" > <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path> <circle cx="12" cy="7" r="4"></circle> </svg>
                Profile
              </NavLink>
              <NavLink to="/" className="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-help-circle align-middle me-1" > <circle cx="12" cy="12" r="10"></circle> <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path> <line x1="12" y1="17" x2="12.01" y2="17"></line> </svg>
                Help Center
              </NavLink>
              <button className="dropdown-item" onClick={logOut}>
                Log out
              </button>
              {/* <NavLink to="/login" className="dropdown-item">
                Log out
              </NavLink> */}
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;